import "../../_namespaces.js";
import "../base.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.Response = class Response extends AssessmentViewer.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.triggerResponseSelected = this.triggerResponseSelected.bind(this);
  }

  initialize() {
    return this.listenTo(this.model, "change:selected", this.triggerResponseSelected);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    return this;
  }

  // EVENT HANDLERS

  triggerResponseSelected() {
    return this.$el.trigger(AssessmentViewer.Events.Response.selected, [this.model, this.model.get("selected")]);
  }
};
AssessmentViewer.Views.Response.prototype.tagName = "div";
AssessmentViewer.Views.Response.prototype.className = "response";
